import React, { useState, useCallback } from 'react';
import { Button, Collapse } from 'react-bootstrap';
import DatePickerJp from '../organisms/DatePickerJp';
import { KeyValue } from '../types/KeyValue';

type Props = {
  result_options?: Array<KeyValue>;
  status_options?: Array<KeyValue>;
  search_params: {
    first_name: string;
    last_name: string;
    kana_first_name: string;
    kana_last_name: string;
    status_from: string;
    status_to: string;
    birthday: string;
    reception_cd: string;
    reception_store: string;
    retailer: string;
    execution_store: string;
    pre_examination_date_from: string;
    pre_examination_date_to: string;
    pre_examination_result: string;
    examination_result: string;
    prefered_date_from: string;
    prefered_date_to: string;
  };
  handleClickSearch: () => void;
  handleClickClear: () => void;
  handleChange: (event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void;
  handleChangeDate: (date: Date, key: string) => void;
  handleBlurSearchparams: (event: React.FocusEvent<HTMLInputElement>) => void;
  is_connecting: boolean;
};

const SearchForm: React.FC<Props> = ({
  search_params,
  result_options,
  status_options,
  handleClickSearch,
  handleClickClear,
  handleChange,
  handleChangeDate,
  handleBlurSearchparams,
  is_connecting,
}) => {
  // 検索条件表示フラグ
  const [is_search_area, setIsSearchArea] = useState(true);
  /**
   * 検索条件の表示切替えを行う
   */
  const isSeachArea = useCallback(() => {
    setIsSearchArea((prev) => !prev);
  }, [setIsSearchArea]);

  return (
    <div id="search">
      <div className="hamburger-menu">
        <div className="hamburger-menu-btn">
          <Button variant="main-color" onClick={isSeachArea}>
            <span className="triangle">{is_search_area ? '▼' : '◀'}</span>
          </Button>
        </div>
      </div>
      <Collapse className="search-area" in={is_search_area}>
        <div>
          <div className="search-container">
            <div className="row my-2">
              <div className="col-md-5 col-sm-10">
                <span className="search-criteria-head">カナ氏名（セイ）</span>
                <input
                  type="text"
                  name="kana_last_name"
                  className="search-form-input"
                  value={search_params.kana_last_name}
                  onChange={handleChange}
                />
                <span className="search-criteria-head-small">（メイ）</span>
                <input
                  type="text"
                  name="kana_first_name"
                  className="search-form-input"
                  value={search_params.kana_first_name}
                  onChange={handleChange}
                />
              </div>

              <div className="col-md-3 col-sm-4">
                <span className="search-criteria-head">案件番号</span>
                <input
                  type="text"
                  className="search-form-input"
                  name="reception_cd"
                  value={search_params.reception_cd}
                  onChange={handleChange}
                  onBlur={handleBlurSearchparams}
                />
              </div>

              <div className="col-md-3 col-sm-4">
                <span className="search-criteria-head">事前審査結果</span>
                <select
                  name="pre_examination_result"
                  className="search-form-input"
                  value={search_params.pre_examination_result}
                  onChange={handleChange}
                >
                  {result_options?.map((option, index) => {
                    return (
                      <option key={index} value={option.key}>
                        {option.value}
                      </option>
                    );
                  })}
                </select>
              </div>
            </div>
            <div className="row my-2">
              <div className="col-md-5 col-sm-4">
                <span className="search-criteria-head">氏名（姓）</span>
                <input
                  type="text"
                  name="last_name"
                  className="search-form-input"
                  value={search_params.last_name}
                  onChange={handleChange}
                />
                <span className="search-criteria-head-small">（名）</span>
                <input
                  type="text"
                  className="search-form-input"
                  name="first_name"
                  value={search_params.first_name}
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-3 col-sm-6">
                <span className="search-criteria-head">本審査結果</span>
                <select
                  name="examination_result"
                  className="search-form-input"
                  value={search_params.examination_result}
                  onChange={handleChange}
                >
                  {result_options?.map((option, index) => {
                    return (
                      <option key={index} value={option.key}>
                        {option.value}
                      </option>
                    );
                  })}
                </select>
              </div>
            </div>
            <div className="row my-2">
              <div className="col-md-5 col-sm-10">
                <span className="search-criteria-head">生年月日</span>
                <DatePickerJp
                  id="birthday"
                  name="birthday"
                  handleChangeDate={(date: Date) => handleChangeDate(date, 'birthday')}
                  selected={
                    search_params.birthday.length > 0 ? new Date(search_params.birthday) : null
                  }
                  customInput={<input type="text" className="search-form-input" />}
                />
              </div>
              <div className="col-md-7 col-sm-6">
                <span className="search-criteria-head">案件進捗</span>
                <select
                  className="search-form-input-large"
                  value={search_params.status_from}
                  onChange={handleChange}
                  name="status_from"
                >
                  <option></option>
                  {status_options?.map((option, index) => {
                    return (
                      <option key={index} value={option.key}>
                        {option.value}
                      </option>
                    );
                  })}
                </select>
                ～
                <select
                  className="search-form-input-large"
                  value={search_params.status_to}
                  onChange={handleChange}
                  name="status_to"
                >
                  <option></option>
                  {status_options?.map((option, index) => {
                    return (
                      <option key={index} value={option.key}>
                        {option.value}
                      </option>
                    );
                  })}
                </select>
              </div>
            </div>
            <div className="row my-2">
              <div className="col-md-5 col-sm-10">
                <span className="search-criteria-head">事前審査申込入力日時</span>
                <DatePickerJp
                  id="pre-examination-date-from"
                  name="pre_examination_date_from"
                  handleChangeDate={(date: Date) =>
                    handleChangeDate(date, 'pre_examination_date_from')
                  }
                  selected={
                    search_params.pre_examination_date_from.length > 0
                      ? new Date(search_params.pre_examination_date_from)
                      : null
                  }
                  customInput={<input type="text" className="search-form-input" />}
                />
                <span className="search-criteria-head-small">～</span>
                <DatePickerJp
                  id="pre-examination-date-to"
                  name="pre_examination_date_to"
                  handleChangeDate={(date: Date) =>
                    handleChangeDate(date, 'pre_examination_date_to')
                  }
                  selected={
                    search_params.pre_examination_date_to.length > 0
                      ? new Date(search_params.pre_examination_date_to)
                      : null
                  }
                  customInput={<input type="text" className="search-form-input" />}
                />
              </div>

              <div className="col-md-5 col-sm-10">
                <span className="search-criteria-head">借入希望日</span>
                <DatePickerJp
                  id="preferred-date-from"
                  name="prefered_date_from"
                  handleChangeDate={(date: Date) => handleChangeDate(date, 'prefered_date_from')}
                  selected={
                    search_params.prefered_date_from.length > 0
                      ? new Date(search_params.prefered_date_from)
                      : null
                  }
                  customInput={<input type="text" className="search-form-input" />}
                />
                <span className="search-criteria-head-small">～</span>
                <DatePickerJp
                  id="preferred-date-to"
                  name="prefered_date_to"
                  handleChangeDate={(date: Date) => handleChangeDate(date, 'prefered_date_to')}
                  selected={
                    search_params.prefered_date_to.length > 0
                      ? new Date(search_params.prefered_date_to)
                      : null
                  }
                  customInput={<input type="text" className="search-form-input" />}
                />
              </div>
            </div>
            <div className="row my-2">
              <div className="col-md-12 col-sm-10">
                <span className="search-criteria-head">店番</span>
                <input
                  type="text"
                  name="reception_store"
                  className="search-form-input"
                  value={search_params.reception_store}
                  onChange={handleChange}
                />
                <input
                  type="text"
                  className="search-form-input"
                  name="retailer"
                  value={search_params.retailer}
                  onChange={handleChange}
                />
                <input
                  type="text"
                  className="search-form-input"
                  name="execution_store"
                  value={search_params.execution_store}
                  onChange={handleChange}
                />
              </div>
            </div>
            <div className="row my-2">
              <div className="col-md-12 col-sm-12">
                <div className="search-btn">
                  <Button variant="main-color" className="btn-clear" onClick={handleClickClear}>
                    クリア
                  </Button>
                  <button
                    className="btn btn-main-color"
                    disabled={is_connecting}
                    onClick={handleClickSearch}
                  >
                    検 索
                  </button>
                  <div className="search-assist-msg mt-1">案件情報の更新は検索ボタンを押下する</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Collapse>
    </div>
  );
};

export default SearchForm;
